import { Block, Flex, ProductColor, Typography } from '@aloft/toolkit-sui';

import { OrderTag } from '../OrderTable/types.ts';

export const OrderCardTags = ({ tags, orderID }: { tags: OrderTag[]; orderID: string }) => {
  const getBackgroundColor = (tag: OrderTag): ProductColor => {
    switch (tag) {
      case OrderTag.Overdue:
        return 'statusOverdue';
      case OrderTag.ROV:
        return 'statusWarning';
      case OrderTag.Revision:
        return 'statusInProgress';
      case OrderTag.Mock:
        return 'surfaceAccent10';
      default:
        return 'surface1';
    }
  };

  const getTextColor = (tag: OrderTag): ProductColor => {
    switch (tag) {
      case OrderTag.Overdue:
        return 'textOffset';
      case OrderTag.Mock:
        return 'textOffset';
      default:
        return 'textPrimary';
    }
  };
  return (
    <Flex gap={2}>
      {tags.map((tag) => (
        <Block
          key={`tags-${orderID}`}
          backgroundColor={getBackgroundColor(tag)}
          padding="2px 8px"
          height="25px"
          borderRadius="5px"
        >
          <Typography
            variant="body1"
            __dangerDoNotUseSx={{ fontWeight: 600 }}
            color={getTextColor(tag)}
          >
            {tag}
          </Typography>
        </Block>
      ))}
    </Flex>
  );
};
